let theatreSeatDetails=[
    {
        id:1,
        name:"Pichaikkaran 2",
    }
]
export default theatreSeatDetails;